export const Pill = ({ icon, cls = 'bg-soft2 text-blue', children }) => (
  <span className={`d-inline-flex align-items-center gap-2 rounded-pill px-3 py-1 fw-bold t-xs text-uppercase ${cls}`}>
    {icon && <i className={`bi bi-${icon}`} />}{children}
  </span>
);
export const Section = ({ bg = '', id, children }) => (
  <section id={id} className={`py-5 ${bg}`}><div className="container py-lg-4">{children}</div></section>
);
export const Head = ({ pill, icon, title, text, dark }) => (
  <div className="text-center mx-auto mb-5" style={{ maxWidth: 780 }}>
    {pill && <Pill icon={icon} cls={dark ? 'bg-navy2 text-gold' : undefined}>{pill}</Pill>}
    <h2 className={`fw-bold text-uppercase t-xl mt-3 ${dark ? 'text-white' : 'text-navy'}`}>{title}</h2>
    {text && <p className={`t-md mb-0 ${dark ? 'text-white-50' : 'text-muted2'}`}>{text}</p>}
  </div>
);
export const IconBox = ({ icon, cls = 'bg-soft2 text-blue' }) => (
  <span className={`d-inline-flex align-items-center justify-content-center rounded-3 ${cls}`} style={{ width: 44, height: 44 }}>
    <i className={`bi bi-${icon}`} />
  </span>
);
